export enum PaymentOccurrenceMode {
  ONE_TIME = 'one-time',
  RECURRING = 'recurring'
}
